import React, { useImperativeHandle, forwardRef, useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Chips } from 'primereact/chips';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';
import axios from "axios";
import { triggerAlert } from "utils/CommonFunctions";

const NotesCompanies = forwardRef(({ customers }, ref) => {
    // link jobs 
    const [visibleLinkJob, setVisibleLinkJob] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [valueNotes, setValueNotes] = useState(['Varun Digital Media']);
    const [popchecked, setPopchecked] = useState(false);
    const [candidateName, setCandidateName] = useState("Anupam Diridhar, John Doe, Amith, Sagar");
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [subject, setSubject] = useState("");
    const [notes, setNotes] = useState("");
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [selectedJobTitles, setSelectedJobTitles] = useState('');
    // Validation states
    const [companyError, setCompanyError] = useState('');
    const [notesError, setNotesError] = useState('');

    const [userId, setUserId] = useState('')

    useEffect(() => {
        const userInfo = JSON.parse(sessionStorage.getItem("user-info"));
        if (userInfo && userInfo.user_details) {
            setUserId([userInfo.user_details.unique_user_id]);
        }
    }, []);

    useImperativeHandle(ref, () => ({
        openLinkJobModal: () => setVisibleLinkJob(true),
    }));

    const handlePopupCheckbox = e => {
        setPopchecked(e.checked);
    };

    const handleIconClick = () => {
        setJobDetailsVisible(true);
    };

    const handleSave = () => {
        if (selectedJobs.length === 0) {
            setCompanyError('Please select at least one company');
            // triggerAlert("error", "Validation Error", "Please select at least one company");
            return;
        }
        setCompanyError('');
        const selectedJobTitles = selectedJobs.map(job => `${job.company_name}`).join(', ');
        setSelectedJobTitles(selectedJobTitles);
        setJobDetailsVisible(false);
    };

    const handleRefresh = () => {
        setSelectedJobs([]);
        setSearchText('');
        setCompanyError('');
    };

    // Notes validation function
    const validateNotes = (notesValue) => {
        if (!notesValue.trim()) {
            return "Notes cannot be empty.";
        }
        if (notesValue.length < 5) {
            return "Notes must be at least 5 characters long.";
        }
        if (notesValue.length > 5000) {
            return "Notes cannot exceed 5000 characters.";
        }
        return "";
    };

    const handleAddNote = async () => {
        let isValid = true;

        if (selectedJobs.length === 0) {
            setCompanyError('Please select at least one company');
            isValid = false;
        } else {
            setCompanyError('');
        }

        const noteValidationMessage = validateNotes(notes);
        if (noteValidationMessage) {
            setNotesError(noteValidationMessage);
            isValid = false;
        } else {
            setNotesError('');
        }

        if (!isValid) return;

        try {
            const companyIds = selectedJobs.map(job => job.company_id).join(',');
            const response = await axios.post(`/api/v1/notes/`, {
                company_id: companyIds,
                notes: notes
            });
            triggerAlert("success", "Success", "Notes Created Successfully!");
            setNotes("");
            setSelectedJobs([]);
            setSelectedJobTitles([]);
            setVisibleLinkJob(false);
        } catch (error) {
            console.error('Error creating note:', error);
            triggerAlert("error", "Error", "Failed to create note");
        }
    };


    const onSelectionChange = (e) => {
        const selected = e.value || [];
        setSelectedJobs(selected);
        setCompanyError('');
    };

    const filteredCustomers = useMemo(() => {
        if (!searchText) return customers;
        const searchLower = searchText.toLowerCase();
        return customers.filter((customer) =>
            (customer.company_name?.toLowerCase() || "").includes(searchLower) ||
            (customer.website?.toLowerCase() || "").includes(searchLower)
        );
    }, [customers, searchText]);

    return (
        <React.Fragment>
            <Tooltip target=".notes" content="Companies Notes" position="bottom" style={{ marginTop: "5px" }} />
            <button
                type="button"
                className="btn btn-secondary icons-btn me-1 notes"
                onClick={() => setVisibleLinkJob(true)}
            >
                <i className="pi pi-file"></i>
            </button>

            <Dialog header={`Note - ${selectedJobTitles}`} visible={visibleLinkJob} onHide={() => {
                setVisibleLinkJob(false); setNotes("");
                setSelectedJobs([]);
                setSelectedJobTitles([]);
            }}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">Type</label>
                            <InputText
                                id="candidate"
                                value="Note"
                                readOnly
                                className="w-full"
                                placeholder="Note"
                                disabled
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">Date</label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)}
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy"
                                hourFormat="12"
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">Companies</label>
                            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                <InputText
                                    id="job"
                                    value={selectedJobTitles}
                                    placeholder="Select Company"
                                    className={`w-full ${companyError ? 'p-invalid' : ''}`}
                                    style={{ paddingRight: '2rem' }}
                                />
                                <i
                                    className="pi pi-chevron-down"
                                    onClick={handleIconClick}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                ></i>
                            </div>
                            {companyError && <small className="p-error">{companyError}</small>}
                            <Dialog
                                header="Companies Details"
                                visible={jobDetailsVisible}
                                onHide={() => setJobDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Jobs"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }}
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row>
                                <DataTable
                                    value={filteredCustomers}
                                    paginator
                                    rows={5}
                                    selection={selectedJobs}
                                    onSelectionChange={onSelectionChange}
                                    dataKey="company_id"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    selectionMode="multiple"
                                    size="small"
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="company_name" header="Companies Name" />
                                    <Column field="website" header="Companies Website" />
                                </DataTable>
                                <div className="d-flex mt-3">
                                    <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                                    <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">Notes</label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setNotes(value);
                                    setNotesError(validateNotes(value));
                                }}
                                rows={3}
                                cols={20}
                                className={`w-full ${notesError ? 'p-invalid' : ''}`}
                                placeholder="Enter your notes here..."
                                autoResize
                            />
                            {notesError && <small className="p-error">{notesError}</small>}
                        </div>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col lg={2}>
                        <div className="d-flex align-items-center">
                            <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-2 mt-2">Private</label>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field notes-chip">
                            <label htmlFor="userId" className="block mb-0">User ID</label>
                            <Chips
                                disabled
                                value={userId}
                                // onChange={(e) => setValueNotes(e.value)} 
                                className="w-full" />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleAddNote}>Add Note</button>
                        </div>
                    </Col>
                </Row>
            </Dialog>
        </React.Fragment>
    );
});

export default NotesCompanies;